"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Api_1 = __importDefault(require("./Api"));
class Comment extends Api_1.default {
    /**
     * @constructor
     */
    constructor(props) {
        super(props);
    }
    /**
     * Get comments on object
     * @see https://developers.podio.com/doc/comments/get-comments-on-object-22371
     * @param {string} type
     * @param {number} ref_id
     * @param {number} offset
     * @param {number} limit
     * @returns {Promise<HttpResponse>}
     */
    getFor(type, ref_id, offset = 0, limit = 100) {
        const requestObj = {
            method: 'get',
            url: `/comment/${type}/${ref_id}?offset=${offset}&limit=${limit}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Get comment API
     * @see https://developers.podio.com/doc/comments/get-a-comment-22345
     * @param {number} comment_id
     * @returns {Promise<HttpResponse>}
     */
    get(comment_id) {
        const requestObj = {
            method: 'get',
            url: `/comment/${comment_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Create comment
     * @see https://developers.podio.com/doc/comments/add-comment-to-object-22340
     * @param {string} type
     * @param {number} id
     * @param {SimpleObject} attributes
     * @param {boolean} alert_invite
     * @param {boolean} silent
     * @param {boolean} hook
     * @returns {Promise<HttpResponse>}
     */
    create(type, id, attributes, alert_invite = false, silent = false, hook = true) {
        const requestObj = {
            method: 'post',
            url: `/comment/${type}/${id}?alert_invite=${alert_invite}&silent=${silent}&hook=${hook}`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Update comment
     * @see https://developers.podio.com/doc/comments/update-a-comment-22346
     * @param {number} comment_id
     * @param {SimpleObject} attributes
     * @returns {Promise<HttpResponse>}
     */
    update(comment_id, attributes) {
        const requestObj = {
            method: 'put',
            url: `/comment/${comment_id}`,
            data: attributes,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Delete comment from Podio
     * @see https://developers.podio.com/doc/comments/delete-a-comment-22347
     * @param {number} comment_id
     * @returns {Promise<HttpResponse>}
     */
    delete(comment_id) {
        const requestObj = {
            method: 'delete',
            url: `/comment/${comment_id}`,
        };
        return this._httpRequest(requestObj);
    }
    /**
     * Comment revisions
     * @see https://developers.podio.com/doc/comments/get-comment-revisions-256356096
     * @param {number} comment_id
     * @returns {Promise<HttpResponse>}
     */
    revisions(comment_id) {
        const requestObj = {
            method: 'get',
            url: `/comment/${comment_id}/revision`,
        };
        return this._httpRequest(requestObj);
    }
}
exports.default = Comment;
